<template>
  <a-layout class="dict-content">
    <a-layout-sider width="296" style="background: #fff;padding:14px;margin-right:10px">
      <org-tree ref="orgTreeDom" @formTitle="addDictEvent" @formNavTitle="editDictEvent" @reGetData="reGetData"></org-tree>
    </a-layout-sider>
    <a-layout-content style="background: #fff;padding: 14px">
      <!-- <div class="content"> -->
      <table-data ref="tableDom"></table-data>
      <!-- </div> -->
    </a-layout-content>
  </a-layout>
</template>

<script>

import orgTree from './modules/orgTree.vue'
import tableData from './modules/tableData.vue'

export default {
  components: {
    orgTree,
     tableData
  },
  data () {
    return {
      formIptTitle: {
        formTitle: '字典详情'
      }
    }
  },
  methods: {
    addDictEvent () {
      this.formIptTitle.formTitle = '新建字典'
    },
    editDictEvent () {
      this.formIptTitle.formTitle = '编辑字典'
    },
    handleSubmit () {
      // 表单提交成功后,重新获取树的数据
      this.$refs['orgTreeDom'].queryDictData(true)
    },
    reGetData () {
      console.log('重新获取数据')
      this.$refs['tableDom'].querySysDeptList()
    }
  }
}
</script>
